import { stringify } from 'querystring';
import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';

const getNaturalLanguageSearchUrl = (query: string, languageRegionCode: LanguageRegionCode) => {
  const searchParams = new URLSearchParams(stringify({ nlq: query }));
  return wrapUrlSafe(`/explore?${decodeURIComponent(searchParams.toString())}`, languageRegionCode);
};

export default getNaturalLanguageSearchUrl;
